module.exports = __webpack_public_path__ + "img/card-bg3.f7086873.png";